<template>
  <div>
    <div id="basic-non-sticky-notification" class="toastify-content hidden flex flex-col sm:flex-row">
      <div class="flex items-center justify-around" v-if="pagedata.message">
        <CheckCircleIcon class="w-6 h-6 text-theme-9 mx-auto" />
        <div class="font-medium text-black">{{ pagedata.message }}</div>
      </div>
    </div>
    <h2 class="intro-y text-lg font-medium mt-10">Parameter Requests</h2>
      <!-- BEGIN: Data List -->
      <div v-if="pagedata.loading == true" class="text-center text-md mt-5">Loading...</div>
      <div v-else>
        <div v-if="params.length == 0" class="text-center text-md mt-5">Requests Not Found</div>
        <div v-else class="intro-y col-span-12 overflow-auto lg:overflow-visible mt-5">
          <table class="table-report -mt-2">
            <thead>
              <tr>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">No</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">User</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Packet</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">T_Id</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Process</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Weight</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Polish WT</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Shape</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Color</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Purity</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Cut</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Polish</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Symm</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Fluer</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Tension</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Stone</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">remark</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(rate, index) in params"
                :key="index"
                class="intro-x"
              >
                <td  class="text-center">{{ index + 1 }}</td>
                <td>
                  <div class="font-medium whitespace-nowrap">{{
                    rate.manager
                  }}</div>
                </td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.packet }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.t_id }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.process }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><div v-if="packets[index].adminpwt" :class="{ 'text-primary-3': rate.weight < packets[index].adminpwt }">{{ rate.weight }}</div><div v-else :class="{ 'text-primary-3': rate.weight < packets[index].polishwt }">{{ rate.weight }}</div></td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><div v-if="packets[index].adminpwt">{{ packets[index].adminpwt }}</div><div v-else>{{ packets[index].polishwt }}</div></td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.shape != packets[index].shape }">{{ rate.shape }}</span> / {{ packets[index].shape }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.color != packets[index].color }">{{ rate.color }}</span> / {{ packets[index].color }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.purity != packets[index].purity }">{{ rate.purity }}</span> / {{ packets[index].purity }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.cut != packets[index].cut }">{{ rate.cut }}</span> / {{ packets[index].cut }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.polish != packets[index].polish }">{{ rate.polish }}</span> / {{ packets[index].polish }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.symmetry != packets[index].symmetry }">{{ rate.symmetry }}</span> / {{ packets[index].symmetry }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.fluerocent != packets[index].fluerocent }">{{ rate.fluerocent }}</span> / {{ packets[index].fluerocent }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.tension != packets[index].tension }">{{ rate.tension }}</span> / {{ packets[index].tension }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span :class="{ 'text-primary-3': rate.stone != packets[index].stone }">{{ rate.stone }}</span> / {{ packets[index].stone }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.remark }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 table-report__action">
                  <div class="flex justify-center items-center">
                    <a class="btn btn-success mr-1 p-1" href="javascript:;" data-toggle="modal"
                      data-target="#edit-confirmation-modal" @click="AcceptRequest(rate.id)">
                      Accept
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- END: Data List -->
  </div>
</template>
<script>
/* eslint-disable */
import { BASE_URL } from '@/constants/config'
import axios from 'axios'
import Toastify from 'toastify-js'
import cash from 'cash-dom'
import { defineComponent, onMounted, reactive, ref, toRef, watch } from 'vue'

export default defineComponent({
  setup() {
    const params = ref([])
    const packets = ref([])
    const pagedata = reactive({
      message: '',
      loading: true
    })
    onMounted(() => {
      getParams()
    })
    function getParams() {
      pagedata.loading = true
      axios({
        url: '/packet/manager-param-request',
        method: 'get',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept':'application/json' } }
      }).then((res) => {
        pagedata.loading = false
        params.value = res.data.params
        packets.value = res.data.packets
      }).catch(() => {
        pagedata.loading = false
      })
    }
    function AcceptRequest(id) {
      axios({
        url: `/packet/manager-accept-param-request/${id}`,
        method: 'get',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept':'application/json' } }
      }).then((res) => {
        pagedata.message = res.data.success
        setTimeout(() => {
          basicNonStickyNotification()
        }, 100)
        setTimeout(() => {
          pagedata.message = ''
        }, 5000);
        getParams()
      })
    }
    const basicNonStickyNotification = () => {
      Toastify({
        node: cash('#basic-non-sticky-notification')
          .clone()
          .removeClass('hidden')[0],
        duration: 5000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    }
    return {
      pagedata,
      packets,
      params,
      AcceptRequest
    }
  }
})
</script>
